<div class="d-flex justify-content-center align-items-center vh-100 bg-login">
    
    <div class="myContainer" id="myContainer">

        <div class="form-container sign-in-container">

            <form class="dirI form" [formGroup]="mdlLogin">

                <img src="../../../assets/Img/fleetYar_logo.png" class="logo mt-2 mb-2">

                <h4 class="bold">ورود</h4>

                <input class="input" type="text" formControlName="strMobile" 
                
                    [dir]="mdlLogin.get('strMobile')?.value != ''  ? 'ltr' : 'rtl' "

                    oninput="this.value = this.value.replace(/[^0-9]/g,'')" maxlength="11"
                
                    placeholder="شماره موبایل" autocomplete="off" />

                <input class="input" type="password" placeholder="کلمه عبور"

                    [dir]="mdlLogin.get('strPassword')?.value != ''  ? 'ltr' : 'rtl' "
                
                    autocomplete="new-password" formControlName="strPassword" />

                <div class="captcha-area col-12">

                    <button type="button" tabindex="-1" class="reload-btn" (click)="get_Captcha()">

                        <i class="fa fa-refresh" aria-hidden="true"></i>

                    </button>

                    <div class="captcha-img">

                        <img src="../../../assets/Img/captcha-bg.png" alt="">

                        <span class="captcha">{{captcha}}</span>

                    </div>
                </div>

                <input class="input text-center" formControlName="strCaptcha" placeholder="کد امنیتی" />

                <button class="button" (click)="login()">ورود</button>

            </form>

        </div>

        <div class="overlay-container">

            <div class="overlay">

                <div class="overlay-panel overlay-left">

                </div>

                <div class="overlay-panel overlay-right">

                    <h2 class="fw-bold"> {{ webAppName }} </h2>

                    <p class="p">جهت ورود به سامانه مشخصات کاربری خود را وارد کنید</p>

                    <div class="d-flex justify-content-center flex-column align-items-center mb-4 pointer">

                        <div class="row mt-5">

                            <a class="text-decoration-none text-white" href="">{{appName}}</a>

                            <span>{{version | faNum}}</span>

                        </div>

                    </div>

                </div>

            </div>

        </div>

    </div>

</div>